const woodyWallProfileHeightTypes = ['25', '42'];

export default woodyWallProfileHeightTypes;
